import { phoneEnterQueued } from './phoneEnter';
import { usePhoneQueue } from './queue';

export function PhoneQueueBar(): React.ReactElement | null {
  const jobs = usePhoneQueue((s) => s.jobs);
  const toast = usePhoneQueue((s) => s.toast);
  const next = jobs[0];
  if (next === undefined && toast === '') return null;
  return (
    <div className="ph-queue" role="status">
      {toast !== '' && <p className="ph-toast">{toast}</p>}
      {next !== undefined && (
        <button type="button" className="ph-queue__go" onClick={() => phoneEnterQueued()}>
          вернись → нога {next.index}: {next.book} · {next.stake} @ {next.odds}
        </button>
      )}
    </div>
  );
}
